import styled from 'styled-components';

import { PickActionType } from '@/core/components/PickActionType';

export const ActionsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
`;

export const StyledPickActionType = styled(PickActionType)`
  margin: 0;
`;

export const EmailText = styled.p`
  font-size: 16px;
  line-height: 28px;
`;
